import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';

class ArticleBtnStore {
  @observable prevData;

  @observable nextData;

  @observable gotoDetail;

  constructor(options = {}) {
    Object.assign(this, options);
  }

  use() {
    useMount(async () => {
      console.log('componentDidMount');
    });
  }
}

export default ArticleBtnStore;
